import axios from "axios";
import { useQuery } from "react-query";

export const useApiQuery = (queryKey, options) => {
  const { extraParams, useQueryOptions } = options || {};
  const resources = [queryKey].flat();
  const lastKey = resources.slice(-1)[0];

  const urlPath =
    typeof lastKey === "string"
      ? resources.join("/")
      : resources.slice(0, -1).join("/");

  const params = typeof lastKey !== "string" ? lastKey : {};

  return useQuery(
    queryKey,
    () => axios.get(`v1/${urlPath}`, { params: { ...params, ...extraParams } }),
    {
      staleTime: 60 * 60 * 1000,
      select: ({ data }) => data,
      ...useQueryOptions,
    }
  );
};
